import React from 'react'
import { Spinner } from '@reward-platform/lift/components'
import { useTranslations } from 'next-intl'
import styles from './SpinnerOverlay.module.scss'

function SpinnerOverlay(): JSX.Element {
  const t = useTranslations('components.spinner_overlay.labels')

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.header}>{t('header')}</h2>
      <h5 className={styles.subheader}>{t('sub_header')}</h5>
      <Spinner role="progressbar" title="Spinner" />
    </div>
  )
}

export default SpinnerOverlay
